import { render, staticRenderFns } from "./AppAnimatedLogo.vue?vue&type=template&id=6d96e6e0&scoped=true&"
import script from "./AppAnimatedLogo.vue?vue&type=script&lang=js&"
export * from "./AppAnimatedLogo.vue?vue&type=script&lang=js&"
import style0 from "./AppAnimatedLogo.vue?vue&type=style&index=0&id=6d96e6e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d96e6e0",
  null
  
)

export default component.exports